import { getLanguages } from "./getLanguages.js";

export default {
    getLanguages,
};
